import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@/assets/css/common.css'




// global config
// App.config.globalProperties.$API_URL = "https://sudarshan.fonetricks.com/api";
// App.config.globalProperties.$SOCKET_URL = "https://sudarshan.fonetricks.com";




createApp(App).use(router).mount('#app')
